import { Component, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { DialogConstant, UrlConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { ApiService } from '../../service/api.service';
import { EventService } from '../../service/event.service';
import { ToastService } from '../../service/toast.service';

@Component({
    selector: 'app-preview-modal',
    templateUrl: './preview-modal.page.html',
    styleUrls: ['./preview-modal.page.scss'],
})
export class PreviewModalPage
{
    private base_url = UrlConstant.BASE;
    private directdl_path = UrlConstant.PC_DIRECTDL;
    private file: any;
    private preview_url = "";

    constructor(
        private navParams: NavParams,
        private auth: AuthService,
        private api: ApiService,
        private event: EventService,
        private toast: ToastService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'preview-modal', value: null});
        const token = await this.auth.getToken();
        this.file = this.navParams.data.file;

        const check = await this.api.getfile(this.file.file_name, (this.auth.empty(this.file.parent_id) ? "" : this.file.parent_id), Date.now(), false, this.file.trash_flg);
        if (this.auth.empty(check)) {
            this.toast.errorNotification(DialogConstant.FILE_DOWNLOAD_ERR);
            return;
        } else if (check.is_storage == 0) {
            this.toast.errorNotification(DialogConstant.FILE_DOWNLOAD_BUSY_ERR);
            return;
        }

        this.preview_url = this.file.url;
    }

    async onDownload()
    {
        let a = <HTMLAnchorElement>document.createElement('A');
        a.download = this.file.file_name;
        a.href = this.file.url;
        a.target = "_blank";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async previewClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'preview-modal', value: null});
    }
}
